import { render, staticRenderFns } from "./MyWalletView.vue?vue&type=template&id=5c1d22d7&scoped=true"
import script from "./MyWalletView.vue?vue&type=script&lang=ts"
export * from "./MyWalletView.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletView.vue?vue&type=style&index=0&id=5c1d22d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d22d7",
  null
  
)

export default component.exports